import ServicePageTemplate from "@/components/ServicePageTemplate";

const DistributionTransportation = () => (
  <ServicePageTemplate
    seoTitle="Distribution Transportation | Varstar Alliance"
    seoDesc="Multi-stop distribution and transportation programs across the US and Canada — pool distribution, final mile, and managed transportation."
    canonical="/services/distribution-transportation"
    h1="From the dock to every doorstep."
    subtitle="Managed distribution and transportation programs that scale with your network."
    ctaText="Get a Distribution Quote"
    body={"Whether you need pool distribution into a region, a multi-stop FTL routing across several DCs, or a managed final-mile program, Varstar designs and runs distribution networks that flex with your demand. One partner, one plan, one team accountable for the whole route."}
    benefits={[
      "Multi-stop FTL and pool distribution programs",
      "Final-mile delivery coordination",
      "Network design and managed transportation",
      "Real-time visibility through our TMS",
      "Scales from a single lane to a national footprint",
    ]}
    equipment={["Multi-Stop FTL", "Pool Distribution", "Final Mile"]}
  />
);

export default DistributionTransportation;